/**
 * Build-time feature flags for surfaces that are switched off wholesale.
 *
 * Each flag has a code default and an optional VITE_* override read at build
 * time, matching the other env-driven switches in this app. The code default
 * is the source of truth so no deploy-time env change is needed to flip one.
 */

/**
 * The whole marketing side (paid + organic) was put dormant on 2026-09-01.
 *
 * Every marketing page, component, test and API client stays in the tree.
 * This flag only decides whether the nav shows the marketing destinations,
 * whether their routes render, and whether the Work Queue and admin settings
 * expose their marketing tabs.
 *
 * REVIVAL: change MARKETING_UI_DEFAULT to true (one line), or set
 * VITE_MARKETING_UI_ENABLED=true at build time.
 */
const MARKETING_UI_DEFAULT = false;

/** Shown in the dormant notice so nobody has to dig for when this happened. */
export const MARKETING_UI_DORMANT_SINCE = '2026-09-01';

export const MARKETING_UI_ENABLED: boolean = readBoolFlag(
  import.meta.env.VITE_MARKETING_UI_ENABLED,
  MARKETING_UI_DEFAULT,
);

function readBoolFlag(raw: string | undefined, fallback: boolean): boolean {
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return fallback;
}
